import { render, staticRenderFns } from "./LoginSuccess.vue?vue&type=template&id=6d4bfb36&scoped=true"
import script from "./LoginSuccess.vue?vue&type=script&lang=js"
export * from "./LoginSuccess.vue?vue&type=script&lang=js"
import style0 from "./LoginSuccess.vue?vue&type=style&index=0&id=6d4bfb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4bfb36",
  null
  
)

export default component.exports